var LGFG = LGFG || {};
LGFG.WF = LGFG.WF || {};

LGFG.WF.MapsApiLoader = LGFG.WF.MapsApiLoader || (function () {

    // Define callback defaults
    var _onSuccess = function () { };
    var _onFailure = function () { };

    // Init module
    var init = function (successCallback, failureCallback) {

        // Override callback defaults if successCallback parameter set
        if (typeof (successCallback) !== 'undefined') {
            _onSuccess = successCallback;
        }

        // Override callback defaults if failureCallback parameter set
        if (typeof (failureCallback) !== 'undefined') {
            _onFailure = failureCallback;
        }
        console.log('loading maps in mapsApiLoader');
        // Check if maps libraries are loaded
        if (typeof (google) === 'undefined' || typeof (google.maps) === 'undefined' || typeof (google.maps.geometry) === 'undefined' || typeof (google.maps.places) === 'undefined') {
            // If required libaries aren't loaded, do so with jQuery
            LGFG.WF.KenticoSettings.get('WFGoogleMapsApiKey', function (value) {
                var scriptUrl = typeof (mapLoaded) === 'undefined'
                    ? `https://maps.googleapis.com/maps/api/js?key=${value}&libraries=geometry,places`
                    : `https://maps.googleapis.com/maps/api/js?key=${value}&libraries=geometry,places&callback=mapLoaded`;
                $.getScript(scriptUrl)
                    .then(_onSuccess, _onFailure);
            });
        } else {
            // If required libaries are loaded, call the _onSuccess callback
            _onSuccess();
        }
    };

    return {
        init: init
    };
})();